import React from 'react';
import { MOCKUP_URL, MOCKUP_WIDTH } from '../data/images';
import type { CropArea } from '../types/mockup';
interface MockupCropProps {
  crop: CropArea;
  alt: string;
  className?: string;
  eager?: boolean;
}

/** Shows one region of the product mockup (a cover, the volume row, the devices). */
export function MockupCrop({
  crop,
  alt,
  className = '',
  eager = false
}: MockupCropProps) {
  return <div className={`relative overflow-hidden ${className}`} style={{
    aspectRatio: `${crop.w} / ${crop.h}`
  }} data-id="element-32" data-mp="mr30ws42xnrr">
      <img src={MOCKUP_URL} alt={alt} loading={eager ? 'eager' : 'lazy'} decoding="async" draggable={false} className="block h-auto select-none" style={{
      width: `${MOCKUP_WIDTH / crop.w * 100}%`,
      maxWidth: 'none',
      marginLeft: `-${crop.x / crop.w * 100}%`,
      marginTop: `-${crop.y / crop.w * 100}%`
    }} data-id="element-33" data-mp="romctldb1ogj" />
    </div>;
}